import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {itemsOfContentSelector} from "../../ducks/content";
import Category from "./Category";

import styles from "./department-products.module.scss";

function DepartmentProducts({items}) {
  return (
    <div className={styles.root}>
      {items.map(({category, title, children}) => (
        <Category key={category} title={title} items={children} />
      ))}
    </div>
  );
}

DepartmentProducts.propTypes = {
  items: PropTypes.array
};

export default connect((state) => ({
  items: itemsOfContentSelector(state)
}))(DepartmentProducts);
